//////////////////////////////////////////////////////////////////////////////
//
//  Interceptors Module
//
//  작성자: MyungHwan Kim
//  생성일: 2025-10-24
//
//  설명: Axios Interceptor 통합 모듈
//       - Request Interceptor
//       - Response Interceptor
//       - Token Refresh Handler
//
//////////////////////////////////////////////////////////////////////////////

import { AxiosInstance } from 'axios';
import { setupRequestInterceptor } from './requestInterceptor';
import { setupResponseInterceptor } from './responseInterceptor';

/**
 * 모든 Interceptor 설정
 * @param axiosInstance Axios 인스턴스
 */
export const setupInterceptors = (axiosInstance: AxiosInstance) => {
  setupRequestInterceptor(axiosInstance);
  setupResponseInterceptor(axiosInstance);
};

// Re-export for convenience
export { setupRequestInterceptor } from './requestInterceptor';
export { setupResponseInterceptor } from './responseInterceptor';
export { handleTokenRefresh, isTokenExpired } from './tokenRefreshHandler';

export default setupInterceptors;

